import RegisterShipmentForm from './registerShipmentForm';

export default RegisterShipmentForm;
